import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useMixpanel } from 'react-mixpanel-browser';

import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { useSticky } from '../../../hooks/useSticky';
import { useAnalyticsMenuItems } from '../../../hooks/useAnalyticsMenuItems';
import { SidebarPageLayout } from '../../layouts/SidebarPageLayout';
import { AnalyticsSpinner } from '../../common/Spinner/AnalyticsSpinner';
import { ReportsManagerTable } from '../../tables/reports-manager/ReportsManagerTable';
import { ReportsManagerFilters } from './ReportsManagerFilters';
import { ReportsManagerIcon } from '../../icons/analytics';
import { cymbioColors } from '../../../utils/colors';

import { getReports } from '../../../store/actions/reportsManager';

import styles from '../Reports/ReportsPage.module.scss';
import stickyStyles from '../../../stylesheets/scss/sticky.module.scss';

export function ReportsManager() {
  const dispatch = useDispatch();
  const [sticky, ref] = useSticky();
  const {
    ui: { loading },
    data,
    filters,
    table: { pagination, sort },
  } = useSelector((state) => state.reportsManager);
  const { sidebarMenuItems } = useAnalyticsMenuItems();
  const { name: supplierName } = useSelector((state) => state.role.supplier);
  const mixpanel = useMixpanel();
  const reportBi = (event, meta) => {
    reportBusinessActionToMixpanel(mixpanel, event, meta);
  };

  useEffect(
    function initializeReport() {
      dispatch(getReports());
      reportBi('report-manager-page', { supplierName });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filters, pagination, sort],
  );

  return (
    <SidebarPageLayout items={sidebarMenuItems} hasStickyHeader>
      <div className={styles.reportWrapper}>
        <div className={stickyStyles.headerStickyObserver} ref={ref} />
        <header className={classNames(styles.reportFilters, sticky ? stickyStyles.headerSticky : '')}>
          <h1>
            <ReportsManagerIcon color={cymbioColors.analytics.darkBlue} />
            Reports Manager
          </h1>

          <ReportsManagerFilters />
        </header>

        {loading || data === null ? (
          <AnalyticsSpinner fullScreen />
        ) : (
          <main>
            <ReportsManagerTable />
          </main>
        )}
      </div>
    </SidebarPageLayout>
  );
}
